import React, { useEffect } from "react";
import { connect } from "react-redux";
import rmsActions from "../../../actions/rmsActions";
import { getAppraisals, getError, isFetching } from "../../../reducers";
import { ActionTypes, DataTypes } from "../../../constants";
import BlankCard from "../../Common/Card/BlankCard";
import ThisTheme from "../../../themes/RMSTheme";
import AppraisalCard from "./Appraisal/AppraisalCard";
import AppraisalErrorCard from "./Appraisal/AppraisalErrorCard";
import AppraisalStartCard from "./Appraisal/AppraisalStartCard";

function RMSWidget({ appraisals, isFetching, getAppraisals, error, appCode }) {
    useEffect(() => {
        getAppraisals(appCode, true);
    }, [getAppraisals, appCode]);

    if (isFetching) return <BlankCard />;

    if (!!error) {
        const is403 = Number(error.errorCode) === 403;
        return (
            <AppraisalErrorCard
                error={is403 ? "Access denied" : "No data available"}
                message={
                    is403
                        ? "Feature not available"
                        : "An error occurred while trying to connect the appraisal service"
                }
            />
        );
    }

    if (appraisals) {
        const openOrReviewAppraisal = appraisals.find(
            (appraisal) =>
                appraisal.status === "open" || appraisal.status === "review"
        );

        if (openOrReviewAppraisal) {
            return (
                <AppraisalCard
                    appraisal={openOrReviewAppraisal}
                    theme={ThisTheme}
                />
            );
        } else {
            return (
                <AppraisalStartCard
                    appraisalCount={appraisals?.length || 0}
                    theme={ThisTheme}
                    appCode={appCode}
                />
            );
        }
    } else {
        return (
            <AppraisalStartCard
                appraisalCount={appraisals?.length || 0}
                theme={ThisTheme}
                appCode={appCode}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    appraisals: getAppraisals(state),
    isFetching: isFetching(state, DataTypes.RMS_APPRAISALS),
    error: getError(state, ActionTypes.GET_RMS_APPRAISALS_FAILURE),
});

export default connect(mapStateToProps, {
    getAppraisals: rmsActions.getAppraisals,
})(RMSWidget);
